import React, { useState } from 'react';
import PageWithHeader from '../../common/PageWithHeader';
import RenderRequisitionHeader from '../common/renderRequisitionHeader';
import RenderRequisitionDetails from '../common/RenderRequisitionDetails';
import { useGetDevelopmentsByIdQuery, useGetProcurementProcessesByIdQuery } from '../../../redux/vmsApi';
import config from "../../../config";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {Button, Typography} from "@mui/material";
import {useRouter} from "../../../hooks/useRouter";
import {useParams} from "react-router-dom";

const ProcurementProcessDetailsPage: React.FC = () => {
  const router = useRouter();
  const params = useParams();
  const isInProcess:boolean=false;
  const { data: procurementProcess, isLoading, isError } = useGetProcurementProcessesByIdQuery({ id: params?.uuid ?? "" });
  const [showQuotationForm, setShowQuotationForm] = useState(false);

  const developmentId = procurementProcess?.requisition?.development.id;
  const { data: development } = useGetDevelopmentsByIdQuery(
    { id: developmentId! },
    { skip: !developmentId }
  );

  const [openDialog, setOpenDialog] = useState<string | null>(null);
  const [selectedSupplier, setSelectedSupplier] = useState<number | null>(null);

  const handleDialogOpen = (path: string) => setOpenDialog(`${config.CDN_URL}/procurement/${path}`);
  const handleDialogClose = () => setOpenDialog(null);


  const handleSelectSupplier = async (index: number) => {
    const newSelection = selectedSupplier === index ? null : index;
    setSelectedSupplier(newSelection);
  };

  if (procurementProcess?.requisition && (!isLoading || !isError)) {
    return (
      <>

        <PageWithHeader>
          <Button color="primary" onClick={() => router.push('/procurement')} sx={{paddingTop: 3}}>
            <ArrowBackIcon/>
            <Typography color="primary" align="left">Procurement Dashboard</Typography>
          </Button>

          <RenderRequisitionHeader development={development || 'Development'} />
          {development && (
            <RenderRequisitionDetails
              procurementProcess={procurementProcess}
              development={development}
              selectedSupplier={selectedSupplier}
              openDialog={openDialog}
              handleDialogOpen={handleDialogOpen}
              handleDialogClose={handleDialogClose}
              handleSelectSupplier={handleSelectSupplier}
              showQuotationForm={showQuotationForm}
              setShowQuotationForm={setShowQuotationForm}
              isInProcess={isInProcess}
            />
          )}

        
        </PageWithHeader>

        
      </>
    );
  } else return <></>;

};

export default ProcurementProcessDetailsPage;
